import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import RegulatorikHeader from './components/RegulatorikHeader/RegulatorikHeader';
import RegulatorikSubNav from './components/RegulatorikSubNav/RegulatorikSubNav';
import NeuigkeitenSection from './components/sections/NeuigkeitenSection/NeuigkeitenSection';
import ArchivSection from './components/sections/ArchivSection/ArchivSection';
import GesetzeSection from './components/sections/GesetzeSection/GesetzeSection';
import './RegulatorikPage.css';

const RegulatorikPage = () => {
    return (
        <div className="regulatorik-page">
            <RegulatorikHeader />
            <RegulatorikSubNav />

            <div className="regulatorik-content">
                <Routes>
                    <Route index element={<Navigate to="neuigkeiten" replace />} />
                    <Route path="neuigkeiten" element={<NeuigkeitenSection />} />
                    <Route path="archiv" element={<ArchivSection />} />
                    <Route path="gesetze" element={<GesetzeSection />} />
                </Routes>
            </div>
        </div>
    );
};

export default RegulatorikPage;